module.exports = __webpack_public_path__ + "img/link-simple-slash.05df1c2d.svg";